import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class PopupDetailGeoposService {
  
  private title: string;
  private id: string;
  private keys: string[] = [];
  private values: string[] = [];
  private id$: Subject<string> = new Subject<string>();
  private keys$: Subject<string[]> = new Subject<string[]>();
  private values$: Subject<string[]> = new Subject<string[]>();
  private lastUpdate$: Subject<string> = new Subject<string>();
  private address$: Subject<string> = new Subject<string>();
  private isVisiblePopup$ = new Subject<boolean>();

  constructor() {}
  getKeys(): Observable<string[]> {
    return this.keys$.asObservable();
  }
  getValues(): Observable<string[]> {
    return this.values$.asObservable();
  }
  setTitle(Id: string) {
    this.id$.next(Id);
  }
  getTitle() {
    if(!environment.production) console.log(this.id$);
    return this.id$.asObservable();
  }
  setAddress(address: string) {
    this.address$.next(address);
  }
  getAddress(): Observable<string> {
    if(!environment.production) console.log(this.address$);
    return this.address$.asObservable();
  }

  setLastUpdate(date: string) {
    this.lastUpdate$.next(date);
  }
  getLastUpdate() {
    return this.lastUpdate$.asObservable();
  }
  setData(properties: any) {
    if(!environment.production) console.log("SETDATA");
    var arrayMaster = Object.entries(properties);
    var row: any;
    this.keys = [];
    this.values = [];
    arrayMaster.forEach((element) => {
      if(!environment.production) console.log(element);
      var array = element.slice();
      var iterator = array.values();
      this.keys.push(iterator.next().value.toString());
      this.values.push(iterator.next().value.toString());
    });

    this.values$.next(this.values);
    this.keys$.next(this.keys);
  }
  checkVisibilityPopup(): Observable<boolean> {
    return this.isVisiblePopup$.asObservable();
  }

  getVisibilityPopup(): Observable<boolean> {
    return this.isVisiblePopup$.asObservable();
  }

  setVisibilityPopup(op) {
    this.isVisiblePopup$.next(op);
  }
}
